// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contentBox {\n  padding: 10px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.textOperator {\n  color: #409eff;\n  cursor: pointer;\n  font-size: 22px;\n}\n", ""]);
// Exports
module.exports = exports;
